@if (hasBattery()) {
	<div class="batteryStatusIconHolder" [@zoomInOnEnter]>
		<sim-battery-status-icon
			[currentPercent]="battery?.level * 100"
			matTooltip="{{ battery?.level * 100 | number: '1.0-0' }}%"
			matTooltipClass="accent"
		/>
		@if (isCharging()) {
			<mat-icon class="chargingIndicator" fontSet="fad" fontIcon="fa-plug" inline matTooltip="Charging" matTooltipClass="accent" />
		}
	</div>
}
